import AudiencerateLogo from '@/assets/icons/audiencerateLogo.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type PoweredByProps = {
  className?: string;
};

export const PoweredBy: FC<PoweredByProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={twMerge('flex items-center gap-2 text-yellow-700', className)}>
      <p>{t('ALL:poweredBy')}</p>
      <p className='font-semibold'>Audiencerate</p>
      <AudiencerateLogo />
    </div>
  );
};
